import { cn } from "@shared/lib/style";
import { AuthorWithDate } from "@shared/ui/author-with-date";
import { BaseImage } from "@shared/ui/base-image";
import { Card } from "@shared/ui/card";

interface FeaturedMainNewsCardProps {
  author: string;
  date: string;
  title: string;
  subTitle: string;
  imageUrl: string;
  className?: string;
  category: string;
}

export function FeaturedMainNewsCard({
  author,
  date,
  title,
  subTitle,
  category,
  imageUrl,
  className,
}: FeaturedMainNewsCardProps) {
  return (
    <div
      className={cn(
        "flex h-[596px] w-[460px] flex-col justify-end bg-cover bg-center",
        "max-sm:h-[457px] max-sm:w-full",
        "bg-black/50",
        className,
      )}
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundBlendMode: "darken",
      }}
    >
      <Card
        className="px-[30px] pb-[50px] text-white"
        extraInfo={
          <AuthorWithDate author={author} date={date} textColor="white" />
        }
        subTitle={<p className="line-clamp-3">{subTitle}</p>}
        title={
          <div>
            <span className="text-body-3 max-sm:text-body-5">{category}</span>
            <h4
              className={cn(
                "text-title-3 break-keep font-semibold",
                "max-sm:text-body-2",
              )}
            >
              {title}
            </h4>
          </div>
        }
      />
    </div>
  );
}

interface FeaturedSubNewsCardProps {
  author: string;
  date: string;
  title: string;
  subTitle: string;
  imageUrl: string;
  className?: string;
}

export function FeaturedSubNewsCard({
  author,
  date,
  title,
  subTitle,
  imageUrl,
  className,
}: FeaturedSubNewsCardProps) {
  return (
    <div
      className={cn(
        "flex h-[596px] w-[370px] flex-col gap-5",
        "max-sm:flex max-sm:h-[435px] max-sm:w-[264px] max-sm:justify-end max-sm:px-5",
        className,
      )}
    >
      <figure
        className={cn(
          "relative flex h-[498px] flex-col bg-black bg-contain bg-center bg-no-repeat",
          "max-sm:h-[342px]",
        )}
      >
        <BaseImage
          alt=""
          fill
          sizes="(max-width: 640px) 264px, 370px"
          src={imageUrl}
        />
      </figure>
      <Card
        contentWrapperClassName="gap-[20px]"
        extraInfo={<AuthorWithDate author={author} date={date} />}
        subTitle={<p className="max-sm:text-body-3 line-clamp-3">{subTitle}</p>}
        title={
          <h4
            className={cn(
              "text-body-1 break-keep font-semibold",
              "max-sm:text-body-2",
            )}
          >
            {title}
          </h4>
        }
      />
    </div>
  );
}
